export enum ETimelineType {
  Simple = 'simple',
  Advanced = 'advanced',
}
